import axios from 'axios';
import axiosWithPayloadInterceptor from '../interceptor/axiosWithPayloadInterceptor';
import {
  HTTP_METHODS,
  URLS,
} from '../helpers/constants';
/**
 * Fetch data from APIs related to Cost Maintenance
 *
 * @author slak4170
 */
class CostViewProxy {
  static async fetchCostViewDataRecords(data) {
    const config = {
      url: `${URLS.COST_DATA_URL}/cost-view`,
      method: HTTP_METHODS.POST,
      data,
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }

  static async fetchCostViewDataDetailRecords(data) {
    const config = {
      url: `${URLS.COST_DATA_URL}/cost-view/${data.priceMasterHistoryId}`,
      method: HTTP_METHODS.GET,
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }

  static async fetchMarginInsightsHistory(data) {
    const config = {
      url: `${URLS.COST_DATA_URL}/cost-view/margin-insights-history/${data.associationId}`,
      method: HTTP_METHODS.GET
    };
    const response = await axios(config);
    return response.status === 204 ? null : response.data;
  }
}

export default CostViewProxy;
